import {Link, useLocation} from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import {useracc, postApi, getCookie, setCookie} from '../utils/functions';

import { BsList } from "react-icons/bs";
import { FaCartPlus, FaCircleUser } from "react-icons/fa6";
import { FaTrashAlt } from "react-icons/fa";

export default function Header(services) {

  const [page, setPage] = useState('');
  const location = useLocation();
  useEffect(() => {
    setPage(location.pathname.split('/')[1] || '');
  }, [location]);

  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    const handleScroll = () => setScrollPosition(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const [cart, setCart] = useState([]);
  async function checkCart() {
    let order = await getCookie('order');
    if( order.length === 0 ) return;
    let params = new URLSearchParams();
    params.append('order', order[0].product);
    params.append('period', order[0].period);
    const x = await postApi('/v3/portal/header', params);
    console.log(x.data);
    if( x.status === 200 ) setCart(x.data.Order);
  }

  const [mobilenav, setMobilenav] = useState(false);

  useEffect(() => {
    checkCart();
  }, []);

  async function removeOrder(id) {
    await setCookie('order', []);
    setCart([]);
  }

  return (
    <div className={`${scrollPosition===0?'':'scrolled'} ${mobilenav?'mobile-nav-active':''}`}>
      <header id="header" /*className="header fixed-top"*/ className={scrollPosition===0?'header fixed-top':'scrolled header fixed-top'}>
        <div className="branding d-flex align-items-cente">
          <div className="container position-relative d-flex align-items-center justify-content-between">
            <Link to={'/'} className="logo d-flex align-items-center">
              <img src={`https://cloud.ultrastream.io/images/logo-us-large.png?d=${Math.floor(Date.now()/1000)}`} alt="" title="logo" />
            </Link>

            <nav id="navmenu" className="navmenu">
              <ul>
                <li><Link to="/" className={page===''?'active':''} onClick={()=>setMobilenav(!mobilenav)}>HOME</Link></li>
                {services.services.map((e, i)=>{
                  return (
                    <li key={i}>
                      {/*e === 'radio' ?
                        <li className="dropdown"><Link to={`/${e.replaceAll(' ','')}`} className={page===e.toLowerCase()?'active':''} onClick={()=>setMobilenav(!mobilenav)}>{e.toUpperCase()}</Link>
                          <ul>
                            <li><Link to={'/radio'}>Visual Radio Station</Link></li>
                            <li><Link to={'/apply'}>Apply Radio Station</Link></li>
                          </ul>
                        </li>
                      :*/
                        <Link to={`/${e.replaceAll(' ','')}`} className={page===e.toLowerCase()?'active':''} onClick={()=>setMobilenav(!mobilenav)}>{e.toUpperCase()}</Link>
                      }
                      
                    </li>
                  )
                })}
                <li className="megamenu-2">
                  <a href="https://portal.ultrastream.io/cart">
                    <FaCartPlus size={24} />
                    {cart.length > 0 &&
                      <div className="cart-items">{cart.length}</div>
                    }
                  </a>
                  <ul className="mobile-megamenu">

                    <li><a href="#">Product Analytics</a></li>
                    <li><a href="#">Customer Insights</a></li>
                    <li><a href="#">Market Research</a></li>

                    <li className="dropdown"><a href="#"><span>Enterprise Software</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                      <ul>
                        <li><a href="#">CRM Solutions</a></li>
                        <li><a href="#">ERP Systems</a></li>
                        <li><a href="#">Workflow Automation</a></li>
                        <li><a href="#">Document Management</a></li>
                        <li><a href="#">Business Intelligence</a></li>
                        <li><a href="#">Integration Platform</a></li>
                      </ul>
                    </li>

                    <li className="dropdown"><a href="#"><span>Development Tools</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                      <ul>
                        <li><a href="#">Code Editors</a></li>
                        <li><a href="#">Version Control</a></li>
                        <li><a href="#">Testing Frameworks</a></li>
                        <li><a href="#">Deployment Tools</a></li>
                        <li><a href="#">API Management</a></li>
                        <li><a href="#">Performance Monitoring</a></li>
                      </ul>
                    </li>

                    <li className="dropdown"><a href="#"><span>Creative Suite</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                      <ul>
                        <li><a href="#">Design Software</a></li>
                        <li><a href="#">Video Editing</a></li>
                        <li><a href="#">Audio Production</a></li>
                        <li><a href="#">Animation Tools</a></li>
                        <li><a href="#">Photo Editing</a></li>
                        <li><a href="#">3D Modeling</a></li>
                      </ul>
                    </li>

                    <li className="dropdown"><a href="#"><span>Resources</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                      <ul>
                        <li><a href="#">Documentation</a></li>
                        <li><a href="#">Tutorials</a></li>
                        <li><a href="#">Community</a></li>
                        <li><a href="#">Blog Posts</a></li>
                      </ul>
                    </li>

                  </ul>

                  
                  <div className="desktop-megamenu">
                    <div className="tab-content">
                      <div className="tab-pane fade show active" id="2190-tab-1" role="tabpanel" aria-labelledby="2190-tab-1-tab">
                        <div className="content-grid">
                          <div className="product-section">
                            <h4>Cart</h4>
                            <div className="product-list">
                              {cart.map((e, i)=>{
                                return (
                                  <div className="product-link d-flex align-items-center justify-content-between">
                                    <div>
                                      <i className="bi bi-people"></i>
                                      <div>
                                        <span>{e.product} - {e.quote}</span>
                                        <small>£{e.period === 1 ? e.pricemonth.toFixed(2) : e.priceyear.toFixed(2)} per {e.period === 1 ? 'Month' : 'Year'}</small>
                                      </div>
                                    </div>
                                    <div style={{cursor: 'pointer'}} onClick={()=>removeOrder(e.id)}><FaTrashAlt size={20} color={'#12a16b'} /></div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        </div>
                        <div className="about">
                          <a href="https://portal.ultrastream.io/cart" className="btn btn-primary">Continue to Cart</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <a href="https://portal.ultrastream.io/">
                    <FaCircleUser size={24} />
                  </a>
                </li>
              </ul>
              <BsList className="mobile-nav-toggle d-xl-none" onClick={()=>setMobilenav(!mobilenav)} />
            </nav>
          </div>
        </div>
      </header>
    </div>
  );
}
